import { Component, Input } from '@angular/core';
import { LayerId, Milliseconds } from '../../../types';
import { TimelineStore } from '../timeline.store';
import { Recorder } from '../../entities/recorder';
import { HorizontalDragEvent } from '../../../shared/directives/horizontal-drag-event';
import { HorizontalDragEndEvent } from '../../../shared/directives/horizontal-drag-end-event';
import { HorizontalDragStartEvent } from '../../../shared/directives/horizontal-drag-start-event';
import { Player } from '../../entities/player';

@Component({
  selector: 'app-timeline-layer',
  templateUrl: './timeline-layer.component.html',
  styleUrls: ['./timeline-layer.component.styl']
})
export class TimelineLayerComponent {
  @Input() layerId: LayerId;
  @Input() canvasPositions: Milliseconds[];

  private dragEventHasHappened: boolean;

  constructor(
    public timelineStore: TimelineStore,
    public recorder: Recorder,
    public player: Player,
  ) {
  }

  onHorizontalDragStart(event: HorizontalDragStartEvent) {
    this.dragEventHasHappened = false;
  }

  onHorizontalDrag(event: HorizontalDragEvent) {
    this.dragEventHasHappened = true;

    if (false === this.recorder.recording && false === this.player.playback) {
      this.timelineStore.currentPosition -= this.timelineStore.convertPixelsToMilliseconds(event.deltaX);
    }
  }

  onHorizontalDragEnd(event: HorizontalDragEndEvent) {
    if (false === this.dragEventHasHappened) {
      this.timelineStore.selectedLayerId = this.layerId;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-layer/timeline-layer.component.ts